import { render, staticRenderFns } from "./Affiliate.vue?vue&type=template&id=5f24fb1c&scoped=true&"
import script from "./Affiliate.vue?vue&type=script&lang=js&"
export * from "./Affiliate.vue?vue&type=script&lang=js&"
import style0 from "./Affiliate.vue?vue&type=style&index=0&id=5f24fb1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f24fb1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
